export default "__VITE_ASSET__Bau4V0pL__"